module.exports = __webpack_public_path__ + "static/media/Airy-Updo.30a5b5ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Airy-Updo.jpg
// module id = 201
// module chunks = 0